import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider, } from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { Pagination } from "../../../_metronic/_partials/controls";
import * as UIHelpers from "../../components/UIHelpers";
import FilterComponent from "../../components/FilterComponent";
import {
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret,
    headerSortingClasses,
} from "../../../_metronic/_helpers";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../_metronic/_partials/controls";
import { Formik, Field } from "formik";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import { NotificationManager } from "react-notifications";
export const initialFilter = {
    filter: {},
    q: '',
    sort: "desc", // asc||desc
    sortBy: "craetedAt",
    skip: UIHelpers.skip,
    limit: UIHelpers.limit,
    page: UIHelpers.page,
};

const GmaeJoiningListComponent = (props) => {
    const dispatch = useDispatch();
    const suhbeader = useSubheader();
    const [filter, setFilter] = useState(initialFilter);
    const [count, setCount] = useState(0);
    const [searchApply, setSearchApply] = useState(false);
    const company = "GJ";
    const [
        contestForSelectedDropdownFilterData,
        setContestForListDropdownFilterData,
      ] = useState([]);
      const [
        contestForDropdownFilterData,
        setContestForDropdownFilterData,
      ] = useState([]);
    suhbeader.setTitle("Html5 Game Wise Joining List");
    suhbeader.setIsSearch(true);
    useEffect(() => {
        filter.q = suhbeader.searchText.q
        setFilter(filter);
        setCount(count + 1);
    }, [suhbeader.searchText]);


   
    const filterChange = (filterData) => {
        filter.q = filterData.q;
        filter.filter = filterData.filter;
        setFilter(filter);
        setCount(count + 1);
    }

    const columns = [
        {
            dataField: "html5Category.name",
            text: "Html5 Game Category",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "name",
            text: "Html5 Game",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "totalJoinedPlayers",
            text: "Total Played",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "playedUserCountRepeted",
            text: "Repeated Played Users Count ",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "playedUserCountUnique",
            text: "unique Played Users Count",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
    ];
    const { currentState } = useSelector(
        (state) => ({ currentState: state.H5Games }),
        shallowEqual
    );
    const { gameWiseJoingList, listLoading, companyDropdownList } = currentState;
    const { totalCount, entities } = gameWiseJoingList;
    useEffect(() => {

        dispatch(actions.fetchCompanyDropdownList());
    
      }, []);
      useEffect(() => {
        if (companyDropdownList && companyDropdownList?.data) {
          // let temp = [{
          //   _id: 0,
          //   label: "All",
          //   value: "all",
          //   baseUrl: "all",
          // }];
          let temp = [];
          const userdata = JSON.parse(localStorage.getItem("userData"));
          const userCompany = userdata?.company || [];
          companyDropdownList.data.forEach((element, i) => {
            // console.log(userCompany.includes(element._id));
            // console.log(!helperFunc.isAdmin());
            // if (!helperFunc.isAdmin()) {
              if (userCompany.includes(element._id)) {
                temp.push({
                  _id: i + 1,
                  label: element.name,
                  value: element._id,
                  baseUrl: element.baseUrl,
                  code:element.code,
                  "data-tokens": element.name,
                });
              }
            // } else {
            //   temp.push({
            //     _id: i + 1,
            //     label: element.name,
            //     value: element._id,
            //     baseUrl: element.baseUrl,
            //     code:element.code,
            //     "data-tokens": element.name,
            //   });
            // }
          });
          setContestForDropdownFilterData(temp);
        }
      }, [companyDropdownList]);
    // useEffect(() => {
    //     if (!listLoading) {
    //         dispatch(actions.fetchGameWiseJoiningList(filter));
    //     }
    // }, [count, dispatch]);
    useEffect(() => {
        if (!listLoading) {
        //   if (isFilterApply) {
        //     filter.dateRange = dateRange;
        //   }
          // Create the payload including the Company-GJ value
          const newFilter = { ...filter };

          console.log("newFilternewFilternewFilter", newFilter)

          newFilter.company = contestForSelectedDropdownFilterData?.code;
        
          if(contestForSelectedDropdownFilterData?.code){
            // Create the payload including the Company-GJ value
            const payload = {
              ...newFilter, // Spread the properties of the newFilter object
              company: contestForSelectedDropdownFilterData?.code,
            };
            dispatch(actions.fetchGameWiseJoiningList(payload));
          }
        }
      }, [count, dispatch]);
    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: UIHelpers.sizePerPageList,
        sizePerPage: filter.limit,
        page: filter.page,
    };
    const applyFilter = async (values) => {
      if (
        contestForSelectedDropdownFilterData == null ||
        contestForSelectedDropdownFilterData.length <= 0
      ) {
        NotificationManager.error("Please Select Company", "Error");
        return false;
      }
    
      setSearchApply(true);
    
      // Create a new filter object based on the current filter
      const newFilter = { ...filter };
      newFilter.company = contestForSelectedDropdownFilterData.code;
    
      // Create the payload including the Company-GJ value
      const payload = {
        ...newFilter, // Spread the properties of the newFilter object
        company: newFilter.company,
      };
    
      console.log("newFilternewFilternewFilter 3", newFilter)
      setFilter(newFilter);
    
      // Dispatch the action with the updated filter
      if (!listLoading) {
        dispatch(actions.fetchGameWiseJoiningList(payload));
      }
    };
    const getHandlerTableChange = (type, data) => {
      if (type === "pagination") {
        const newFilter = { ...filter };
        newFilter.limit = data?.sizePerPage || newFilter.limit;
        newFilter.page = data?.page || newFilter.page;
        newFilter.skip = (newFilter.page - 1) * newFilter.limit;
        setFilter(newFilter);
        setCount(count + 1);
    
        // Update the filter with pagination data
        filter.limit = newFilter.limit;
        filter.skip = (newFilter.page - 1) * newFilter.limit;
        filter.page = newFilter.page;
    
        // Create the payload including the Company-GJ value
        const payload = {
          ...newFilter,
          company: contestForSelectedDropdownFilterData.code,
        };

        console.log("newFilternewFilternewFilter 4", newFilter.page, (newFilter.page - 1), newFilter.limit, (newFilter.page - 1) * newFilter.limit)
    
        // Dispatch the action with the updated filter
        if (!listLoading) {
          dispatch(actions.fetchGameWiseJoiningList(payload));
        }
      }
    
      if (type === "sort") {
          filter.sort = data.sortOrder;
          filter.sortBy = data.sortField;
          setFilter(filter);
          setCount(count + 1);
  
          // Create the payload including the Company-GJ value
          const payload = {
              ...filter,
              company: company,
          };

          console.log("newFilternewFilternewFilter 5", filter)
  
          // Dispatch the action with the updated filter
          if (!listLoading) {
              dispatch(actions.fetchGameWiseJoiningList(payload));
          }
      }
  }
  
    const createFormInputs = () => {
        return (
          <div
            className="report-filter-bLock border-0 row align-items-center"
            style={{ padding: "0px 0", margin: "0px", marginBottom: "40px" }}
          >
            <Formik
              initialValues={{}}
              onSubmit={(values) => {
                console.log("val::22", values);
                applyFilter(values);
              }}
            >
              {({ handleSubmit, values }) => (
                <div className="col-lg-12 col-md-12 mt-4" >
                  {/* <div className="row m-0 p-0"> */}
                  <form
                    onSubmit={handleSubmit}
                    className="form form-filter w-100"
                    autoComplete="off"
                    style={{ marginTop: "10px" }}
                  >
                    <div className="form-group row m-0 align-items-center z-index: 10"  >
                      <div
                        className="col-lg-4 col-md-6 z-index: 10 !important pl-0"
                        // style={{ maxWidth: "325px" }}
                      >
                        <label>Select Company</label>
                        <DropdownReactSelect
                          placeholder={"Company"}
                          name={"Company"}
                          value={contestForSelectedDropdownFilterData}
                          // isMulti={values.isShared == 'true' ? true : false}
                          isMulti={false}
                          isClearable={true}
                          isSearchable={true}
                          closeMenuOnSelect={true}
                          options={contestForDropdownFilterData}
                          onChange={setContestForListDropdownFilterData}
                        />
                         
                      </div>
                       
                      <div className="justify-content-end mx-2">
                        <button
                          type="submit"
                          className="btn btn-dark"
                          style={{ width: "130px", marginTop: "20px" }}
                        >
                          Search
                        </button>
    
                      </div>
    
                    </div>
    
                  </form>
                  {/* </div> */}
                </div>
              )}
            </Formik>
    
          </div>
        );
      };
    return (
        <>
            <Card>
                <CardHeader title="Html5 Game Wise Joining List"></CardHeader>
                {createFormInputs()}
                {searchApply === true ? ( // searchApply === true
          entities?.length == 0 && listLoading === false ? (
            UIHelpers.dataTableNoData()
          ) : (
                <CardBody>
                    <FilterComponent filterChange={filterChange} />
                    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                        {({ paginationProps, paginationTableProps }) => {
                            return (
                                <Pagination
                                    isLoading={listLoading}
                                    paginationProps={paginationProps}
                                >
                                    <BootstrapTable
                                        wrapperClasses="table-responsive"
                                        bordered={false}
                                        classes="table table-head-custom table-vertical-center overflow-hidden"
                                        bootstrap4
                                        remote
                                        keyField="_id"
                                        data={entities ? entities : []}
                                        columns={columns}
                                        onTableChange={getHandlerTableChange}
                                        {...props}
                                        {...paginationTableProps}
                                    >
                                        <PleaseWaitMessage entities={entities} />
                                        <NoRecordsFoundMessage entities={entities} />
                                    </BootstrapTable>
                                </Pagination>
                            );
                        }}
                    </PaginationProvider>
                </CardBody>
                     )
                     ) : (
                       // <h4 className="text-center">Please select search</h4>
                       ""
                     )}
            </Card>
        </>
    )
}
export default GmaeJoiningListComponent;